import { React, useState, Fragment, useEffect } from 'react';
import { useForm, Controller, useNa } from 'react-hook-form';
// import { ThemeProvider, StyledEngineProvider, makeStyles } from '@mui/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import TopActions from '../actions/TopActions';
import Toast from '../actions/Toasts';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import apiService from '../../services/apiServices';
import validationSchema from '../../services/validationSchema';
import InputController from '../../controllers/InputController';
import SelectController from '../../controllers/SelectController';
import { yupResolver } from '@hookform/resolvers/yup';
import EditIcon from '@mui/icons-material/Edit';
import { Switch } from '@mui/material';
// import { useNavigate } from "react-router-dom";

export default function AddWorker() {
  //const classes = useStyles();
  //const navigate = useNavigate();
  const alert = { open: false, message: '', variant: '' };
  const [toast, setToast] = useState(alert);
  const [workTypes, setWorkTypes] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [branch, setBranch] = useState([]);
  const {
    register,
    handleSubmit,
    control,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });
  const salaryTypes = [{ id: 0, name: "" }, { id: 1, name: "Mujore" }, { id: 2, name: "Me ore" }]
  const brutoNeto = [{ id: 0, name: "" }, { id: 1, name: "Bruto" }, { id: 2, name: "Neto" }]
  const contractExtension = [{ id: 0, name: "" }, { id: 1, name: "Mujore" }, { id: 2, name: "Vjetore" }]
  const [templates, setTemplates] = useState([])

  const toLowerKeys = (obj) => {
    return Object.keys(obj).reduce((accumulator, key) => {
      key = accumulator[key.charAt(0).toLowerCase() + key.slice(1, -1) + key.slice(-1).toLocaleLowerCase()] = obj[key];
      return accumulator;
    }, {});
  }

  const getTemplates = () => {
    apiService().get('contractsTemplates')
      .then(response => {
        if (response.success) {
          let arr = []
          let data = response.data
          data?.forEach(d => {
            arr.push(toLowerKeys(d))
          })
          setTemplates(arr)
        }
      })
  }

  useEffect(() => {
    apiService()
      .get('worktype')
      .then((response) => {
        if (response.success) {
          setWorkTypes(response.data);
          //console.log(response.data);
        } else {
          console.error('Error:' + response.errorMessage);
        }
      });

    apiService()
      .get('department')
      .then((response) => {
        if (response.success) {
          setDepartments(response.data);
          //console.log(response.data);
        } else {
          console.error('Error:' + response.errorMessage);
        }
      });
    apiService()
      .get('branch')
      .then((response) => {
        if (response.success) {
          setBranch(response.data);
          //console.log(response.data);
        } else {
          console.error('Error:' + response.errorMessage);
        }
      });

    setValue("WithTax", true)
    setValue("EmployeeTax", 5);
    setValue("EmployerTax", 5);
    getTemplates()
  }, []);

  const onSubmit = (data) => {
    console.log(data)
    // data.WorkType = data.WorkType.id;
    // data.SalaryType = data.SalaryType.id;
    // data.Department = data.Department.id;
    // data.BranchId = data.BranchId.id;
    data.BankName = null;
    data.BankAccount = null;
    data.Image = !data.Image ? "" : data.Image;
    console.log(data);
    apiService()
      .post('workers', data)
      .then((response) => {
        console.log(response)
        if (response.success) {
          //saveWorkerContract(data, response.data)
          setToast({
            open: true,
            message: 'U ruajten me sukses!',
            variant: 'success',
          });
          window.location.href = `#/workerlist/editworker/${response.data.id}`
          // navigate(`#/workerlist/editworker/${response.data.id}`, { replace: true });
        } else {
          setToast({
            open: true,
            message: 'Ka ndodhur nje gabim!',
            variant: 'error',
          });
        }
      });
  };

  const saveWorkerContract = (data, worker) => {
    data.WorkerId = worker.id;
    data.ContractType = data.ContractExtension.id;
    data.TermsOfContract = "";
    //data.WorkType = data.WorkType.id;
    //data.SalaryType = data.SalaryType.id;
    //data.Department = data.Department.id;
    //data.BranchId = data.BranchId.id;
    data.BrutoNeto = data.BrutoNeto.id;
    data.Template = data.Template.id
    data.createdBy = "";
    apiService()
      .post('workerContract', data)
      .then((response) => {
        console.log(response)
        if (response.success) {
          setToast({
            open: true,
            message: 'U ruajten me sukses!',
            variant: 'success',
          });
          window.location.href = `#/workerlist/editworker/${worker.id}`
        } else {
          setToast({
            open: true,
            message: 'Ka ndodhur nje gabim!',
            variant: 'error',
          });
        }
      });
  };

  const setImage = (e) => {
    if (e) {
      let file = e.target.files[0]
      var reader = new FileReader()
      let src = ''
      reader.onloadend = function () {
        var data = reader.result.split(',')[1]
        src = 'data:image/png;base64,' + data
        setValue('Image', src)
      }
      reader.readAsDataURL(file)
    }
  }

  const setTaxes = (isTrue) => {
    setValue('WithTax', isTrue);
    if (!isTrue) {
      setValue('EmployeeTax', 0);
      setValue('EmployerTax', 0);
    }
    else {
      !watch('EmployeeTax') ? setValue('EmployeeTax', 5) : setValue('EmployeeTax', watch('EmployeeTax'));
      !watch('EmployerTax') ? setValue('EmployerTax', 5) : setValue('EmployerTax', watch('EmployerTax'));
    }
  }

  return (
    <div className="">
      <Fragment>
        <Toast {...toast} />
        <TopActions
          newHref="/workerlist/addworker"
          save={handleSubmit(onSubmit)}
        />

        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Personal Data
            </Typography>
            <form>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={12} lg={12}>
                  <div class="avatar-upload">
                    <div class="avatar-edit">
                      <input
                        error={errors.Image}
                        control={control}
                        onChange={(e) => setImage(e)}
                        type="file"
                        id="imageUpload"
                      />
                      <label for="imageUpload" id="imgLabel"><EditIcon /></label>
                    </div>
                    <div class="avatar-preview">
                      <div id="imagePreview"
                        style={{ backgroundImage: `url(${watch('Image')})` }}>
                      </div>
                    </div>
                  </div>
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                {/* <Grid item xs={12} sm={3} lg={4}>
                  <InputController
                    error={errors.Image}
                    control={control}
                    //register={{ ...register('Image') }}
                    onFieldChange={(e) => setImage(e)}
                    //name="Image"
                    type="file"
                  />
                  
                </Grid> */}
                <Grid item xs={12} sm={3} lg={3}>
                  <InputController
                    placeholder="Numri Personal / Pasaporta"
                    error={errors.PersonalId}
                    control={control}
                    register={{ ...register('PersonalId') }}
                    name="PersonalId"
                    type="number"
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={3}>
                  <InputController
                    placeholder="Emri"
                    error={errors.FirstName}
                    control={control}
                    register={{ ...register('FirstName') }}
                    name="FirstName"
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={3}>
                  <InputController
                    placeholder="Emri i prindit"
                    error={errors.ParentName}
                    control={control}
                    register={{ ...register('ParentName') }}
                    name="ParentName"
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={3}>
                  <InputController
                    placeholder="Mbiemri"
                    error={errors.LastName}
                    control={control}
                    register={{ ...register('LastName') }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={3}>
                  <InputController
                    placeholder="Datelindja"
                    error={errors.Birthday}
                    control={control}
                    type="date"
                    register={{ ...register('Birthday') }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={3}>
                  {/* <FormLabel component="legend">Gjinia </FormLabel> */}
                  <Controller
                    render={({ field }) => (
                      <RadioGroup row aria-label="gender" {...field}>
                        <FormControlLabel
                          sx={{ pl: 2 }}
                          value="0"
                          control={<Radio size="small" />}
                          label="Femër"
                        />
                        <FormControlLabel
                          value="1"
                          control={<Radio size="small" />}
                          label="Mashkull"
                        />
                      </RadioGroup>
                    )}

                    name="Gender"
                    {...register('Gender')}
                    control={control}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={3}>
                  {/* <FormLabel component="legend">Statusi martesor </FormLabel> */}
                  <Controller
                    render={({ field }) => (
                      <RadioGroup row aria-label="maritalStatus" {...field}>
                        <FormControlLabel
                          value="0"
                          control={<Radio />}
                          label="Beaqar/e"
                        />
                        <FormControlLabel
                          value="1"
                          control={<Radio />}
                          label="I/e martuar"
                        />
                      </RadioGroup>
                    )}
                    defaultValue=""
                    name="MaritalStatus"
                    {...register('MaritalStatus')}
                    control={control}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={3}>
                  <InputController
                    placeholder="Kualifikimi"
                    error={errors.Qualification}
                    control={control}
                    register={{ ...register('Qualification') }}
                  />
                </Grid>

                <Grid item xs={12} sm={3} lg={3}>
                  <InputController
                    placeholder="Email"
                    error={errors.Email}
                    control={control}
                    register={{ ...register('Email') }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={3}>
                  <InputController
                    placeholder="Telefoni"
                    error={errors.Phone}
                    control={control}
                    register={{ ...register('Phone') }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={3}>
                  <InputController
                    placeholder="Adresa"
                    error={errors.Address}
                    control={control}
                    register={{ ...register('Address') }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={3}>
                  <InputController
                    placeholder="Kodi Postal"
                    error={errors.PostalCode}
                    control={control}
                    register={{ ...register('PostalCode') }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={3}>
                  <InputController
                    placeholder="Shteti"
                    error={errors.Country}
                    control={control}
                    register={{ ...register('Country') }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={3}>
                  <InputController
                    placeholder="Qyteti"
                    error={errors.Place}
                    control={control}
                    register={{ ...register('Place') }}
                  />
                </Grid>
                {/* <Grid item xs={12} sm={3} lg={3}>
                  <InputController
                    placeholder="Data e fillimit"
                    error={errors.StartDate}
                    control={control}
                    type="date"
                    register={{ ...register('StartDate') }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={3}>
                  <InputController
                    placeholder="Data e mbarimit"
                    error={errors.EndDate}
                    control={control}
                    type="date"
                    register={{ ...register('EndDate') }}
                  />
                </Grid>

                <Grid item xs={12} sm={3} lg={3}>
                  <SelectController
                    placeholder="Lloji i punes"
                    error={errors.WorkType}
                    control={control}
                    options={workTypes}
                    name="WorkType"
                    register={{ ...register('WorkType') }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={3}>
                  <SelectController
                    placeholder="Filiali"
                    error={errors.BranchId}
                    control={control}
                    options={branch}
                    name="BranchId"
                    register={{ ...register('BranchId') }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={3}>
                  <SelectController
                    placeholder="Departamenti"
                    error={errors.Department}
                    control={control}
                    options={departments}
                    name="Department"
                    register={{ ...register('Department') }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={3}>
                  <SelectController
                    placeholder="Tipi i pages"
                    error={errors.SalaryType}
                    control={control}
                    options={salaryTypes}
                    name="SalaryType"
                    register={{ ...register('SalaryType') }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={3}>
                  <InputController
                    placeholder="Paga bazë"
                    error={errors.BaseSalary}
                    control={control}
                    symbol="€"
                    register={{ ...register('BaseSalary') }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={3}>
                  <SelectController
                    placeholder="Bruto/Neto"
                    error={errors.BrutoNeto}
                    control={control}
                    options={brutoNeto}
                    name="BrutoNeto"
                    register={{ ...register('BrutoNeto') }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={3}>
                  <InputController
                    placeholder="Paga per orë"
                    error={errors.HourSalary}
                    control={control}
                    symbol="€"
                    register={{ ...register('HourSalary') }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={3}>
                  <InputController
                    placeholder="Paga per orë ditë vikendi"
                    error={errors.HourSalaryWeekend}
                    control={control}
                    symbol="€"
                    register={{ ...register('HourSalaryWeekend') }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={3}>
                  <InputController
                    placeholder="Paga per orë ditë feste"
                    error={errors.HourSalaryHoliday}
                    control={control}
                    symbol="€"
                    register={{ ...register('HourSalaryHoliday') }}
                  />
                </Grid>
                <Grid item xs={12} sm={1} lg={1}>
                  <FormControlLabel
                    control={<Switch
                      error={errors.WithTax}
                      control={control}
                      name="WithTax"
                      register={{ ...register('WithTax') }}
                      onChange={(e) => setTaxes(e.target.checked)}
                      checked={watch("WithTax")}
                      defaultChecked={true}
                    />}
                    label="Kontributi"
                  />
                </Grid>
                {watch('WithTax') ?
                  <>
                    <Grid item xs={12} sm={2} lg={2}>
                      <InputController
                        placeholder="Kontributi i punëtorit"
                        error={errors.EmployeeTax}
                        control={control}
                        symbol="%"
                        value={watch('EmployeeTax') || 5}
                        register={{ ...register('EmployeeTax') }}
                        type="number"
                      />
                    </Grid>
                    <Grid item xs={12} sm={3} lg={3}>
                      <InputController
                        placeholder="Kontributi i punëdhënësit"
                        error={errors.EmployerTax}
                        control={control}
                        symbol="%"
                        value={watch('EmployerTax') || 5}
                        register={{ ...register('EmployerTax') }}
                        type="number"
                      />
                    </Grid>
                  </>
                  : ''}
                <Grid item xs={12} sm={3} lg={3}>
                    <SelectController
                      placeholder="Shablloni i kontratës"
                      error={errors.Template}
                      control={control}
                      options={templates}
                      name="Template"
                      register={{ ...register('Template') }}
                    />
                  </Grid>
                <Grid item xs={12} sm={!watch('WithTax') ? 2 : 3} lg={!watch('WithTax') ? 2 : 3}>
                  <InputController
                    placeholder="Emri i bankes"
                    error={errors.BankName}
                    control={control}
                    register={{ ...register('BankName') }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={3}>
                  <InputController
                    placeholder="Xhirollogaria"
                    error={errors.BankAccount}
                    control={control}
                    register={{ ...register('BankAccount') }}
                  />
                </Grid>
                <Grid item xs={12} sm={3} lg={3}>
                  <SelectController
                    placeholder="Vazhdimi i kontratës"
                    error={errors.ContractExtension}
                    control={control}
                    options={contractExtension}
                    name="ContractExtension"
                    register={{ ...register('ContractExtension') }}
                  />
                </Grid> */}
              </Grid>
            </form>
          </CardContent>
        </Card>
      </Fragment>
    </div>
  );
}
